import { useState } from "react";
import { navLinks } from "@/mocks/homeData";

function Brand() {
  return (
    <a href="#top" className="flex items-center gap-2.5 cursor-pointer group">
      <span className="grid place-items-center w-9 h-9 rounded-md bg-primary-500 text-background-50 text-sm font-bold">
        黑
      </span>
      <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
        抖音<span className="text-primary-600">黑料</span>
      </span>
    </a>
  );
}

export default function SiteNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6">
        <Brand />
        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-foreground-950 cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>
        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#note"
            className="flex h-10 items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-bookmark-line text-base leading-none" />
            收藏当目录
          </a>
        </div>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="grid h-10 w-10 place-items-center rounded-md border border-background-200 text-foreground-700 md:hidden cursor-pointer"
          aria-label="打开菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-xl`} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#note"
            onClick={() => setOpen(false)}
            className="mt-3 flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 text-sm font-medium text-background-50 cursor-pointer"
          >
            <i className="ri-bookmark-line text-base" />
            收藏当目录
          </a>
        </div>
      )}
    </header>
  );
}